const ErrorCodes = {
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    TOO_MANY_REQUESTS: 429,
    GATEWAY_TIMEOUT: 504,
    NETWORK_READ_TIMEOUT: 598,
};
export default ErrorCodes;
